var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { PageJumpMethod } from './types';
import { clamp } from './helpers';
import PageButton from './page-button.vue';
import CurrentPageMixin from './mixin/current-page';
var TablePagination = /** @class */ (function (_super) {
    __extends(TablePagination, _super);
    function TablePagination() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.PageJumpMethod = PageJumpMethod;
        _this.jumpMethod = null;
        _this.isLoading = false;
        return _this;
    }
    Object.defineProperty(TablePagination.prototype, "pageStatus", {
        get: function () {
            return this.$format(this.$gettext('Page {currentPage} / {total_page_count}'), { currentPage: this.currentPage, total_page_count: this.pagination.total_page_count });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TablePagination.prototype, "nearByPageNumbers", {
        get: function () {
            var padding = 2;
            var start = this.pagination.current_page_number - padding;
            var end = this.pagination.current_page_number + padding;
            var extraForward = 0;
            var extraBackward = 0;
            if (start < padding) {
                extraForward = padding - start;
                start = 0;
            }
            if (end > this.pagination.total_page_count) {
                extraBackward = end - this.pagination.total_page_count;
            }
            start = clamp(start - extraBackward, 1);
            end += extraForward;
            if (end > this.pagination.total_page_count) {
                var diff = end - this.pagination.total_page_count;
                end = this.pagination.total_page_count;
                start = clamp(start - diff + 1, 1);
            }
            var pages = [];
            for (var i = start; i <= end; i++) {
                pages.push(i);
            }
            return pages;
        },
        enumerable: false,
        configurable: true
    });
    TablePagination.prototype.onJump = function (pageNumber, callback) {
        var _this = this;
        this.isLoading = true;
        this.emitJump(pageNumber, function () {
            _this.isLoading = false;
            callback();
        });
    };
    TablePagination.prototype.jump = function (method, index) {
        var _this = this;
        this.jumpMethod = method;
        this.isLoading = true;
        this.emitJump(index, function () {
            _this.isLoading = false;
            _this.jumpMethod = null;
        });
    };
    TablePagination.prototype.emitJump = function (index, callback) {
        this.$emit('jump', index, callback);
    };
    __decorate([
        Prop({ type: Object })
    ], TablePagination.prototype, "pagination", void 0);
    TablePagination = __decorate([
        Component({
            components: { PageButton: PageButton }
        })
    ], TablePagination);
    return TablePagination;
}(Mixins(CurrentPageMixin)));
export default TablePagination;
